import { z } from "zod/v4";

const EnvironmentBuildSchema = z.object({
  env: z.string(),
  build: z.string(),
});

const EnvironmentBuildResponseSchema = EnvironmentBuildSchema.extend({
  buildTime: z.string(),
});

const EnvironmentBuildSearchSchema = EnvironmentBuildSchema.partial();

export { EnvironmentBuildResponseSchema, EnvironmentBuildSearchSchema };
